// Fit-score presentation helpers (Tailwind classes). The math lives in
// @rolefit/domain/fit; this is UI-only. Fit scores are never color-only; always
// paired with the numeral. Ported from apps/web/lib/scoring.ts (fitTone).
export function fitTone(overall: number): { text: string; chip: string } {
  if (overall >= 7.5) {
    return {
      text: 'text-emerald-700 dark:text-emerald-300',
      chip: 'bg-emerald-500/10 text-emerald-700 ring-1 ring-inset ring-emerald-500/25 dark:text-emerald-300',
    };
  }
  if (overall >= 5) {
    return {
      text: 'text-amber-700 dark:text-amber-300',
      chip: 'bg-amber-500/10 text-amber-700 ring-1 ring-inset ring-amber-500/25 dark:text-amber-300',
    };
  }
  return {
    text: 'text-rose-700 dark:text-rose-300',
    chip: 'bg-rose-500/10 text-rose-700 ring-1 ring-inset ring-rose-500/25 dark:text-rose-300',
  };
}

export const STATE_LABELS: Record<string, string> = {
  discovered: 'Discovered',
  tailoring: 'Tailoring',
  ready: 'Ready',
  applied: 'Applied',
  responded: 'Responded',
  interview: 'Interview',
  offer: 'Offer',
  rejected: 'Rejected',
  archived: 'Archived',
};

export const BOARD_STATES = ['discovered', 'tailoring', 'ready', 'applied', 'responded', 'interview', 'offer'];
